<app-layout-terminal
  *ngIf="terminalPublico"
  [logo]="logoEmpresaHeader"
  [iniciais]="iniciaisEmpresaHeader"
  [nome]="nomeEmpresaHeader"
  [agora]="agora"
  [mensagem]="mensagem">
  <app-tela-registrador
    [agora]="agora"
    [dataFormatada]="dataCentralFormatada()"
    [empregadores]="empregadores"
    [(empregadorSelecionado)]="empregadorSelecionado"
    [terminalPublico]="terminalPublico"
    [terminalAutorizado]="terminalAutorizado"
    [terminalNome]="terminalNome"
    [terminalToken]="terminalToken"
    [zoomCamera]="estadoTerminalPublico.zoomCamera"
    [areaLeituraCameraPercentual]="estadoTerminalPublico.areaLeituraCameraPercentual"
    [(codigoAtivacao)]="codigoAtivacaoTerminal"
    [ativandoTerminal]="ativandoTerminal"
    (alterarEmpregador)="aoAlterarEmpregador()"
    (ativarTerminal)="ativarTerminalPublico()"
    (mensagem)="mensagem = $event">
  </app-tela-registrador>
</app-layout-terminal>

<div *ngIf="!terminalPublico && !usuarioLogado" class="app-shell">
  <main class="container py-4">
    <app-alerta-mensagem [mensagem]="mensagem"></app-alerta-mensagem>
    <app-tela-login
      [formulario]="loginForm"
      [logo]="logoEmpresaHeader"
      [iniciais]="iniciaisEmpresaHeader"
      [nomeEmpresa]="nomeEmpresaHeader"
      [primeiroAcesso]="primeiroAcesso"
      (entrar)="entrar()"
      (criarPrimeiroAcesso)="criarPrimeiroAcesso()">
    </app-tela-login>
  </main>
</div>

<app-layout-administrativo
  *ngIf="!terminalPublico && usuarioLogado"
  [logo]="logoEmpresaHeader"
  [iniciais]="iniciaisEmpresaHeader"
  [nome]="nomeEmpresaHeader"
  [agora]="agora"
  [aba]="aba"
  [adminGlobal]="isAdminGlobal"
  [mensagem]="mensagem"
  [ajustesPendentes]="ajustesPendentes"
  [feriasPendentes]="feriasPendentes"
  (selecionar)="selecionarAbaAdministrativa($event)"
  (menu)="abrirMenuGerencial()"
  (sair)="sair()">
  <app-tela-registrador
    *ngIf="aba === 'registrador'"
    [agora]="agora"
    [dataFormatada]="dataCentralFormatada()"
    [empregadores]="empregadores"
    [(empregadorSelecionado)]="empregadorSelecionado"
    [terminalPublico]="false"
    [terminalAutorizado]="terminalAutorizado"
    [terminalNome]="terminalNome"
    [terminalToken]="terminalToken"
    [zoomCamera]="1"
    [areaLeituraCameraPercentual]="100"
    [(codigoAtivacao)]="codigoAtivacaoTerminal"
    [ativandoTerminal]="ativandoTerminal"
    (alterarEmpregador)="aoAlterarEmpregador()"
    (ativarTerminal)="ativarTerminalPublico()"
    (mensagem)="mensagem = $event">
  </app-tela-registrador>

  <app-tela-empregador
    *ngIf="isAdminGlobal && aba === 'empregador'"
    [empregador]="empregador"
    [empregadores]="empregadores"
    [empregadorSelecionado]="empregadorSelecionado"
    [urlTerminal]="urlTerminalEmpregador"
    (selecionar)="selecionarEmpregadorBuscaGenerico($event)"
    (mensagem)="mensagem = $event"
    (excluir)="aoExcluirEmpregador()"
    (limpar)="aoLimparEmpregador($event)"
    (salvar)="aoSalvarEmpregador($event)">
  </app-tela-empregador>

  <app-tela-funcionario
    *ngIf="aba === 'funcionario'"
    [(funcionario)]="funcionario"
    [empregadores]="empregadores"
    [funcionarios]="funcionarios"
    [departamentos]="departamentos"
    [jornadas]="jornadas"
    [(buscaPersistida)]="buscaFuncionarioCadastro"
    [(empregadorSelecionado)]="empregadorSelecionado"
    (alterarEmpregador)="aoAlterarEmpregador()"
    (mensagem)="mensagem = $event"
    (selecionar)="aoSelecionarFuncionario($event)"
    (digitouCpf)="aoDigitarCpfFuncionario()"
    (excluir)="aoExcluirFuncionario()"
    (limpar)="aoLimparFuncionario($event)"
    (salvar)="aoSalvarFuncionario($event)">
  </app-tela-funcionario>

  <app-tela-departamentos
    *ngIf="aba === 'departamentos'"
    [empregadores]="empregadores"
    [(empregadorSelecionado)]="empregadorSelecionado"
    (carregarDepartamentos)="carregarDepartamentos()"
    (mensagem)="mensagem = $event">
  </app-tela-departamentos>

  <app-tela-relogio
    *ngIf="aba === 'relogio'"
    [(aba)]="relogioAba"
    [empregadores]="empregadores"
    [departamentos]="departamentos"
    [(empregadorSelecionado)]="empregadorSelecionado"
    [relogioEmpregador]="relogioEmpregador"
    [jornada]="jornadaPonto"
    [jornadas]="jornadas"
    [terminal]="dispositivo"
    [terminais]="dispositivos"
    (alterarEmpregador)="aoAlterarEmpregador()"
    (carregarRelogio)="carregarRelogioEmpregador()"
    (carregarJornadas)="carregarJornadas()"
    (carregarTerminais)="carregarDispositivos()"
    (mensagem)="mensagem = $event"
    (terminalChange)="dispositivo = $event"
    (relogioLimpo)="aoLimparRelogio($event)"
    (relogioSalvo)="aoSalvarRelogio($event)"
    (jornadaLimpa)="aoLimparJornada($event)"
    (jornadaSalva)="aoSalvarJornada($event)"
    (jornadaExcluida)="aoExcluirJornada()"
    (terminalLimpo)="aoLimparTerminal($event)"
    (terminalSalvo)="aoSalvarTerminal()"
    (terminalRevogado)="aoRevogarTerminal()"
    (terminalExcluido)="aoExcluirTerminal()">
  </app-tela-relogio>

  <app-tela-exportacao
    *ngIf="aba === 'exportacao'"
    [empregadores]="empregadores"
    [(empregadorSelecionado)]="empregadorSelecionado"
    [funcionarios]="funcionarios"
    [departamentos]="departamentos"
    (empregadorSelecionadoChange)="aoAlterarEmpregadorExportacao()"
    (mensagem)="mensagem = $event">
  </app-tela-exportacao>

  <app-tela-pendencia-ponto
    *ngIf="aba === 'pendencias'"
    [empregadores]="empregadores"
    [(empregadorSelecionado)]="empregadorSelecionado"
    [funcionarios]="funcionarios"
    [departamentos]="departamentos"
    [jornadas]="jornadas"
    (alterarEmpregador)="aoAlterarEmpregadorExportacao()"
    (mensagem)="mensagem = $event">
  </app-tela-pendencia-ponto>

  <app-tela-usuarios
    *ngIf="isAdminGlobal && aba === 'usuarios'"
    [empregadores]="empregadores"
    [departamentos]="departamentos"
    [(empregadorSelecionado)]="empregadorSelecionado"
    (carregarDepartamentos)="carregarDepartamentos()"
    (mensagem)="mensagem = $event">
  </app-tela-usuarios>

  <app-tela-solicitacoes
    *ngIf="aba === 'ajustes'"
    tipo="ajustes"
    [empregadores]="empregadores"
    [empregadorSelecionado]="empregadorSelecionado"
    (empregadorSelecionadoChange)="empregadorSelecionado = $event; aoAlterarEmpregadorExportacao()"
    (mensagem)="mensagem = $event"
    (atualizarResumo)="carregarResumoSolicitacoes()">
  </app-tela-solicitacoes>

  <app-tela-auditoria
    *ngIf="aba === 'auditoria'"
    [empregadores]="empregadores"
    [(empregadorSelecionado)]="empregadorSelecionado"
    [funcionarios]="funcionarios"
    (empregadorSelecionadoChange)="carregarFuncionariosLista()"
    (mensagem)="mensagem = $event">
  </app-tela-auditoria>
</app-layout-administrativo>
